import React from 'react';
import PropTypes from 'prop-types';
import connectWithStore from '../../hocs/connectWithStore';
import Event from './event';
import { eventsSet, loadMoreEvents, setLoading } from '../controls/filters/filters_actions';
import { buildLocalizedUrl } from '../../utils/locale';

class Events extends React.Component {
  constructor(props) {
    super(props);
    props.eventsSet(props.init.eventsList);
  }

  loadMoreEvents = async () => {
    const { pagination, selectedType, selectedSeason, selectedMonth, selectedTournament } = this.props;
    if (pagination.hasMore && !this.props.loading) {
      this.props.setLoading(true);
      
      try {
        const nextPage = pagination.currentPage + 1;
        
        // Build query parameters with current filters
        const params = new URLSearchParams({
          page: nextPage,
          per_page: pagination.perPage
        });
        
        // Add filter parameters
        if (selectedType && selectedType.value !== 'All') {
          params.append('type', selectedType.value);
        }
        
        if (selectedSeason && selectedSeason !== 0) {
          params.append('season', selectedSeason);
        }
        
        if (selectedMonth && selectedMonth.value !== 'All') {
          params.append('month', selectedMonth.value);
        }

        // Preserve the tournament filter across pagination (0 = All Tournaments → omit)
        if (selectedTournament) {
          params.append('tournament_id', selectedTournament);
        }

        const response = await fetch(`${buildLocalizedUrl('scheduler.json')}?${params.toString()}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          this.props.loadMoreEvents(data);
        }
      } catch (error) {
        console.error('Error loading more events:', error);
      } finally {
        this.props.setLoading(false);
      }
    }
  };

  render() {
    const { filteredEvents, pagination, loading } = this.props;
    
    return (
      <div>
        {filteredEvents.map((e) => (<Event event={e} t_controls={this.props.init.t_controls} key={e.id}/>))}
        
        {pagination.hasMore && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button 
              className="button button-primary"
              onClick={this.loadMoreEvents}
              disabled={loading}
            >
              {loading ? 'Loading...' : 'Load More Events'}
            </button>
          </div>
        )}
      </div>
    )
  }
}

Events.propTypes = {
  init: PropTypes.shape({
    eventsList: PropTypes.shape({
      events: PropTypes.array.isRequired,
      pagination: PropTypes.shape({
        currentPage: PropTypes.number.isRequired,
        perPage: PropTypes.number.isRequired,
        totalCount: PropTypes.number.isRequired,
        totalPages: PropTypes.number.isRequired,
        hasMore: PropTypes.bool.isRequired
      }).isRequired
    }).isRequired,
    t_controls: PropTypes.object.isRequired
  }),
};

const mapStateToProps = (state) => ({
  ...state.events,
  selectedType: state.events.selectedType,
  selectedSeason: state.events.selectedSeason,
  selectedMonth: state.events.selectedMonth,
  selectedTournament: state.events.selectedTournament,
});

const mapDispatchToProps = {
  eventsSet,
  loadMoreEvents,
  setLoading,
};

export default connectWithStore(
  mapStateToProps,
  mapDispatchToProps,
)(Events);
